import React from "react";
import {
    Card,
    CardContent,
    CardHeader,
    Container,
    Grid,
    Typography,
} from "@mui/material";
import BreadcrumbBuilder from "../Common/Breadcrumbs/BreadcrumbBuilder";

function Settings() {
    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <Card className="card" data-cy="settings-card">
                        <CardHeader
                            disableTypography={true}
                            title={
                                <Typography component="h2" variant="h2">
                                    Settings
                                </Typography>
                            }
                            subheader={
                                <Typography variant="p">
                                    This is where we will display the system
                                    settings
                                </Typography>
                            }
                        />
                        <CardContent></CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}

export default Settings;
